export default {
	computed: {
		attrs() {
			const attrs = {
				type: this.type,
				placeholder: this.placeholder,
				required: this.required,
				step: this.step,
				maxlength: this.maxlength,
				min: this.min,
				max: this.max,
				dateFormat: this.dateFormat,
				timeFormat: this.timeFormat,
				table: this.table,
				columnSearch: this.columnSearch,
				retKey: this.retKey,
				retLabel: this.retLabel,
				decimals: this.decimals,
				multiple: this.multiple
			};

			if (this.gestiosField) {
				if (this.placeholder === null && this.gestiosField.Placeholder) {
					attrs.placeholder = this.gestiosField.Placeholder;
				}

				if (!this.type && this.gestiosField.Type) {
					const syncType = this.gestiosField.Type.toLowerCase();

					switch (syncType) {
						case 'number':
							attrs.type = 'integer';
							break;

						default:
							attrs.type = syncType;
					}
				}

				if (attrs.required === null) attrs.required = this.gestiosField.Required;

				switch (attrs.type) {
					case 'relation':
						if (this.gestiosVars) {
							if (attrs.table === null) attrs.table = this.gestiosVars.table;
							if (attrs.retLabel === null) attrs.retLabel = this.gestiosVars.return[0];
							if (attrs.retValue === null) attrs.retValue = this.gestiosVars.column;

							if (this.multiple === null) {
								if (this.gestiosVars.multiple !== undefined) {
									attrs.multiple = this.gestiosVars.multiple === 'true';
								} else {
									attrs.multiple = false;
								}
							}
						}
						break;

					case 'double':
						if (this.gestiosVars) {
							if (this.gestiosVars.decimal) {
								attrs.decimals = this.gestiosVars.decimal;
								let step = '0.';
								for (let i = 1; i < this.gestiosVars.decimal; i += 1) {
									step += '0';
								}
								step += '5';

								if (attrs.step === null) attrs.step = step;
							}
						}
						break;

					case 'datetime':
					case 'date':
						if (Object.keys(this.gestiosRules).length > 0) {
							Object.keys(this.gestiosRules).forEach((rule) => {
								const value = this.gestiosRules[rule];

								if (rule === 'valid_date') {
									switch (value) {
										case 'Y-m-d H:i:s':
											attrs.dateFormat = 'YYYY-MM-DD HH:mm:ss';
											break;

										default:
											attrs.dateFormat = 'YYYY-MM-DD';
									}
								}
							});
						} else if (attrs.type === 'datetime') {
							attrs.dateFormat = 'YYYY-MM-DD HH:mm:ss';
						} else if (attrs.type === 'date') {
							attrs.dateFormat = 'YYYY-MM-DD';
						}

						break;

					case 'time':
						if (Object.keys(this.gestiosRules).length > 0) {
							Object.keys(this.gestiosRules).forEach((rule) => {
								const value = this.gestiosRules[rule];

								if (rule === 'valid_date') {
									switch (value) {
										case 'H:i:s':
											attrs.timeFormat = 'HH:mm:ss';
											break;

										case 'H:i':
											attrs.timeFormat = 'HH:mm';
											break;

										default:
											attrs.timeFormat = 'HH:mm:ss';
									}
								}
							});
						} else if (attrs.type === 'time') {
							attrs.timeFormat = 'HH:mm:ss';
						}

						break;

					default:
				}
			}

			if (attrs.retLabel === null) attrs.retLabel = '_EntityId';
			if (!attrs.type) attrs.type = 'text';

			return attrs;
		}
	}
};
